<ami-dialog-message [setting]="message"></ami-dialog-message>
<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Crear Usuario"
  [style]="{ width: '750px' }"
  (onHide)="onClose()"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="p-fluid p-formgrid grid">
          <div class="field col-12 md:col-3">
            <label>Rol</label>
            <p-dropdown
              formControlName="roleId"
              [options]="roles"
              optionLabel="name"
              optionValue="id"
            ></p-dropdown>
          </div>

          <div class="field col-12 md:col-9"></div>

          <div class="field col-12 md:col-6">
            <label>Nombres</label>
            <input pInputText formControlName="names" type="text" />
            <div
              *ngIf="
                fg.get('names').invalid &&
                (fg.get('names').dirty || fg.get('names').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('names').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('names').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 5.</small
                >
              </div>
              <div *ngIf="fg.get('names').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máxima de 255.</small
                >
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6">
            <label>Apellidos</label>
            <input pInputText formControlName="surnames" type="text" />
            <div
              *ngIf="
                fg.get('surnames').invalid &&
                (fg.get('surnames').dirty || fg.get('surnames').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('surnames').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('surnames').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 5.</small
                >
              </div>
              <div *ngIf="fg.get('surnames').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máxima de 255.</small
                >
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6">
            <label>Usuario</label>
            <input pInputText formControlName="username" type="text" />
            <div
              *ngIf="
                fg.get('username').invalid &&
                (fg.get('username').dirty || fg.get('username').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('username').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('username').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 5.</small
                >
              </div>
              <div *ngIf="fg.get('username').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máxima de 255.</small
                >
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6">
            <label>Contraseña</label>
            <p-password
              formControlName="password"
              [toggleMask]="true"
            ></p-password>
            <div
              *ngIf="
                fg.get('password').invalid &&
                (fg.get('password').dirty || fg.get('password').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('password').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('password').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 5.</small
                >
              </div>
              <div *ngIf="fg.get('password').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máxima de 255.</small
                >
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-8"></div>
          <div class="field col-12 md:col-2">
            <button
              pButton
              pRipple
              (click)="onClose()"
              icon="pi pi-times"
              class="p-button-text"
              label="No"
            ></button>
          </div>
          <div class="field col-12 md:col-2">
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              class="p-button-text"
              icon="pi pi-check"
              [disabled]="fg.invalid"
              label="Si"
            ></button>
          </div>
        </div>
      </form>
    </div></div
></p-dialog>
